define([
	"dojo/_base/declare",
	"csi/heading/String",
	"csi/locale"
], function(declare,StringRen,locale) {

	return declare(StringRen, {
		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: disable filtering
			return null;
		},
		
		toValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return localized name
			return locale.resource(ctx.getNode().$Name);
		}
	});
});